import {strings} from "./Strings"
import { getAllApplicableCultures } from "./CurrentCulture";

export default class StringLocaliser {
    private cultures: string[];
    private fallbackCulture = "en";

    constructor(private culture: string) {
        this.cultures = getAllApplicableCultures(culture);
        this.cultures.push(this.fallbackCulture);
    }

    public getString(key: string) {
        for (let c of this.cultures) {
            let culture = strings[c];
            if (!culture)
                continue;

            let s = culture[key];
            if (s)
                return s;
        }

        return "";
    }
}